"use client";

import ErrorPage from "@components/error";
import { useIsShopsite } from "@context/DomainContext";
import { joinClassNames } from "@utils/helpers";
import { useTranslations } from "next-intl";
import Link from "next/link";
import { useEffect } from "react";

export default function EventPageError({
  error,
  reset,
}: {
  error: Error;
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  const t = useTranslations("EventPage.fetcherror");
  const isShopsite = useIsShopsite();

  return (
    <ErrorPage
      heading={
        <>
          <span className="sr-only">{t("heading")}</span>
          {t("oops")}
        </>
      }
      subheading={t("subheading")}
      bodyText={t.rich("bodytext", {
        button: (chunks) => (
          <Link
            href={"/contact"}
            className={joinClassNames(
              "font-semibold",
              isShopsite ? "text-blue-500 visited:text-purple-500" : ""
            )}
          >
            {chunks}
          </Link>
        ),
      })}
      reset={reset}
    />
  );
}
